import { cn } from "./cn";

/** An environment's tier; registry environment names are free, so colours follow the tier. */
export type EnvTier = "development" | "staging" | "production";

export const envTiers: readonly EnvTier[] = ["development", "staging", "production"];

/** The mock's .env-chip colours (dev, uat, prod) by tier. */
export const tierChipClass: Record<EnvTier, string> = {
  development: "bg-dev-soft text-dev",
  staging: "bg-uat-soft text-uat",
  production: "bg-prod text-prod-ink",
};

/** An environment's name in its tier colour. */
export function EnvBadge({
  tier,
  name,
  className,
}: {
  tier: EnvTier;
  name: string;
  className?: string;
}) {
  return (
    <span
      data-tier={tier}
      className={cn(
        "inline-flex h-[22px] items-center gap-[5px] rounded-[6px] px-2 text-xs font-bold tracking-[0.02em] whitespace-nowrap",
        tierChipClass[tier],
        className,
      )}
    >
      {name}
    </span>
  );
}
